// Types
import { ImageData } from '../ResumeLoadImages/types';
import { AnimalsType } from '../tables/summaryTables/AnimalsTable/types';
import { AuxiliaryMachineryType } from '../tables/summaryTables/AuxiliaryMachineryTable/types';
import { MaterialsType } from '../tables/summaryTables/MaterialsTable/types';
import { BudgetItemsType } from '../tables/summaryTables/BudgetItemsTable/types';
import { OperatorsType } from '../tables/summaryTables/OperatorsTable/types';
import { VehiclesType } from '../tables/summaryTables/VehiclesTable/types';
import { UNSPECIFIC } from '../../../types/utils';

export type ContentCardResumeProps = {
  works?: {
    work: string;
    company: string;
    operatorsNumber: string | number;
  }[];
  routes: string[];
  isActionEditedBoolean: boolean;
  roid: string;
  actionStatus?: string;
  date: string;
  hour: string;
  capitol: string;
  subCapitol: string;
  concession: string;
  roadDirections: string;
  road: string;
  pkInit: string;
  pkEnd: string;
  track: string;
  city: string;
  direction?: 'top' | 'down' | 'both' | typeof UNSPECIFIC;
  margin?: 'left' | 'right' | 'both' | typeof UNSPECIFIC;
  lane: string;
  leftButton?: string;
  rightButton?: string;
  description: string;
  // Bug descripciones (2026-06-05): el resumen muestra validada (1ª) + operario (2ª),
  // solo las que tengan valor. `description` queda como fallback legacy.
  descriptionValidated?: string | null;
  operatorDescription?: string | null;
  creatorName?: string | null;
  registeredByName?: string | null;
  notes?: string;
  asset?: string;
  assetSwitch?: boolean;
  activity?: string;
  isMaterialTableDisplayed: boolean;
  isAnimalsTableDisplayed: boolean;
  isMachineryTableDisplayed: boolean;
  isBudgetItemsTableDisplayed: boolean;
  materialsData?: MaterialsType[];
  animalsData?: AnimalsType[];
  machineryData?: AuxiliaryMachineryType[];
  budgetItemsData?: BudgetItemsType[];
  operators: OperatorsType[];
  vehicles: VehiclesType[];
  startDate: string;
  startHour: string;
  endDate: string;
  endHour: string;
  // Fechas-hora ISO completas (opcionales). Cuando están, la jornada se
  // calcula con timestamps completos (incluye días) — mismo criterio que el
  // wizard OperatorsAndVehicles. Sin ellas, fallback al cálculo HH:MM.
  registerInitDate?: string;
  registerEndDate?: string;
  /** Actuació bàsica: pestaña con su horario (plan 2026-10-08). */
  basicSchedule?: boolean;
  // Hora de llegada (opcional): no participa en el cálculo de horas.
  arrivalDate?: string;
  arrivalHour?: string;
  totalHours: string;
  totalOperators: string;
  element: string;
  laneCutting: boolean;
  sketch?: {
    id: string;
    date: string;
    name?: string;
    road?: string;
  };
  images?: ImageData[];
  mapCenter: Coordinates;
  path: Coordinates[];
  /** Ubicación puntual (pkInit === pkEnd): se pinta un marcador, no la línea. */
  mapPoint?: Coordinates | null;
  geolocation?: Coordinates;
  isExternal?: boolean;
  // Actuación simultánea: marca el total de horas-persona como "no suma" (las
  // horas guardadas son 0 porque el operario ya cuenta en su trabajo principal).
  isSimultaneous?: boolean;
  onEditAction?: () => void;
  onContinueAction?: () => void;
  // Validate button props
  validateButton?: string;
  showValidateButton?: boolean;
  isValidating?: boolean;
  onValidateAction?: () => void;
  // Pending certification button props (Tarea #7)
  pendingCertificationButton?: string;
  showPendingCertificationButton?: boolean;
  isMarkingPendingCertification?: boolean;
  onPendingCertificationAction?: () => void;
  onStatusClick?: () => void;
};

type Coordinates = {
  lat: number;
  lng: number;
};

export const marginArrow = {
  left: 'Esquerra (←)',
  right: 'Dret (→)',
  both: 'Tots dos (↔)',
  unspecific: 'Sense especificar',
};

export const directionArrow = {
  top: '(↑)',
  down: '(↓)',
  both: '(↕)',
  unspecific: 'Sense especificar',
};
export interface dataTabs {
  label: string;
  content: JSX.Element;
}
